// extracted by mini-css-extract-plugin
export default {"input-wrapper":"WasteTreatmentDropdown_input-wrapper__PY0kW","menu":"WasteTreatmentDropdown_menu__9LPjo"};